var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreateYourOwn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53122 16.4233L16.4143 9.54664C17.6196 10.0056 19.0351 9.75009 20.0063 8.77984C21.0529 7.73416 21.2686 6.17278 20.6536 4.91439L18.5773 6.98876L17.2978 6.71966L17.0285 5.44135L19.1063 3.36548C17.8457 2.74754 16.2797 2.96209 15.2314 4.00942C14.2603 4.97966 14.0045 6.39386 14.4639 7.59808L7.58079 14.4747C6.37545 14.0157 4.95995 14.2712 3.9888 15.2415C2.94215 16.2872 2.72648 17.8486 3.34147 19.1069L5.41775 17.0326L6.69725 17.3017L6.96662 18.58L4.88881 20.6559C6.14937 21.2738 7.71541 21.0592 8.76367 20.0119C9.73486 19.0417 9.99059 17.6275 9.53122 16.4233Z",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5736 20.368L13.2617 16.0601L16.2973 13.0273L20.6092 17.3353C21.1277 17.8533 21.1277 18.6931 20.6092 19.2112L19.4513 20.368C18.9328 20.8861 18.0921 20.8861 17.5736 20.368Z",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87891 5.78711L11.0777 10.9811",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01351 6.65185L3.11719 4.39344L4.51189 3L6.77243 4.89456L5.01351 6.65185Z",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3021 13.0274C15.8597 13.4694 15.1425 13.4694 14.7001 13.0274L13.8164 12.1445",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2626 16.0615C13.705 15.6196 13.705 14.903 13.2626 14.461L12.3789 13.5781",
    stroke: "#07094F",
    strokeWidth: 1.54286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateYourOwn);
export default __webpack_public_path__ + "static/media/icon-create-your-own.f1546ebff12dad5081cf538898a9414a.svg";
export { ForwardRef as ReactComponent };